import React from "react";
import PropTypes from "prop-types";
import { isNil } from "ramda";
import { connectSearchBox } from "react-instantsearch-dom";

import FilterAlgoliaSearch from "components/FilterAlgoliaSearch";
import AlgoliaConfigure from "components/AlgoliaConfigure";
import { ALGOLIA_FILTERS, TEMPLATE_GROUP_TYPE_NAMES } from "enums";
import AlgoliaCardsPresenter from "presenters/AlgoliaCardsPresenter";

import SearchResults from "../SearchResults";

const AlgoliaSearchBox = ({ featuredEcards, loading, currentRefinement }) => {
  const limit = isNil(featuredEcards) ? 0 : AlgoliaCardsPresenter.limit(featuredEcards);

  return (
    <div>
      <AlgoliaConfigure clickAnalytics sendTokenOnlyForPaidUser hitsPerPage={limit} />
      <FilterAlgoliaSearch
        attribute={ALGOLIA_FILTERS.templateGroupTypeName}
        defaultRefinement={[
          TEMPLATE_GROUP_TYPE_NAMES.starringYouEcard,
          TEMPLATE_GROUP_TYPE_NAMES.starringYouVertical,
          TEMPLATE_GROUP_TYPE_NAMES.starringYouInvite,
          TEMPLATE_GROUP_TYPE_NAMES.starringYouInviteGif,
        ]}
      />
      {!loading && currentRefinement && <SearchResults featuredEcards={featuredEcards} />}
    </div>
  );
};

AlgoliaSearchBox.propTypes = {
  featuredEcards: PropTypes.shape(),
  loading: PropTypes.bool,
  currentRefinement: PropTypes.string,
};

const SearchBox = connectSearchBox(AlgoliaSearchBox);

export default SearchBox;
